import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import * as api from "core-module/services/api";
import loadForm from "core-module/hoc/loadForm";
import { useSelector } from "react-redux";

// @material-ui/core components
import Phone from "@material-ui/icons/Phone";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  buttonBox: {
    display: "flex",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
};
const ContactUS = (props) => {
  const { classes } = props;
  const vipStatus = useSelector((state) => state.services.ids.isVip);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Phone />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Contact Us</h4>
            </CardHeader>
            <CardBody className={classes.buttonBox}>
              <GridContainer align="center" justify="center">
                <GridItem xs={12}>
                  <h3 className={classes.cardTitle}>
                    <br />
                    {vipStatus && (
                      <span>
                        <strong>VIP Support Number:</strong>{" "}
                        <a
                          href="tel:+1780-614-6000"
                          style={{ textDecoration: "underline", color: "blue" }}
                        >
                          1-780-614-6000
                        </a>
                        <br />
                        <span style={{ color: "red" }}>
                          *Dedicated support line
                        </span>
                        <br />
                        <span style={{ color: "red" }}>
                          **Next business day service guarantee
                        </span>
                        <br /> <br />
                      </span>
                    )}
                    <strong>Toll Free Number:</strong>{" "}
                    <a
                      href="tel:+1866-390-3928"
                      style={{ textDecoration: "underline", color: "blue" }}
                    >
                      1-866-390-3928
                    </a>
                    <br /> <br />
                    <strong> Email:</strong>{" "}
                    <a
                      href="mailto:support@mcsnet.ca"
                      style={{ textDecoration: "underline", color: "blue" }}
                    >
                      support@mcsnet.ca
                    </a>
                    <br /> <br />
                    <strong>Address: </strong>
                    4810 50th Ave
                    <br />
                    PO Box 98
                    <br />
                    St Paul, AB
                    <br />
                    T0A3A0
                  </h3>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};
export default withStyles(styles)(ContactUS);
